<template>
  <div>
    <p class="mb-10 mt-10" style="font-size: 25pt; text-align: center" v-if="publicacion">
      COMENTARIOS DE {{publicacion.Data.InitialTitle.es.toUpperCase()}}
    </p>
    <p class="mb-10 mt-10" style="font-size: 25pt; text-align: center" v-else>
      No se encontraron comentarios
    </p>
    <!-- <p class="mb-10" style="font-size: 20pt; text-align: center">
      Este es tú espacio de configuracion, aquí puedes registrar, editar y
      administrar: <br />
      Variables, Indices, Clima a Largo Plazo y crear Publicaciones.
    </p> -->

    <v-card outlined>
      <v-toolbar flat>
        <v-btn @click="irAtras" icon>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title class="grey--text"
          >{{ comentarios.length }} Comentario(s)</v-toolbar-title
        >

        <v-spacer></v-spacer>
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text>
        <v-row>
          <v-col cols="12" class="pa-0">
            <v-list v-if="comentarios.length > 0" two-line subheader>
              <v-list-item v-for="item in comentarios" :key="item.Name">
                <v-list-item-content>
                  <v-list-item-title>{{ item.Username }}</v-list-item-title>
                  <v-list-item-title>{{ item.Email }}</v-list-item-title>
                  <p class="mb-0" style="line-height: 20px">
                    {{ item.Content }}
                  </p>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <div v-else class="my-2 d-flex justify-center">
              <p style="font-size: 12pt" class="mb-0">
                No hay comentarios registrados
              </p>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import api from "@/api/api";

export default {
  name: "Home",
  data() {
    return {
      comentarios: [],
      loadingScreen: false,
      publicacion: {},
    };
  },
  mounted() {
    this.getCommentarios();
    this.getPublication();
  },
  methods: {

    async getPublication() {
      try {
        const data = await api.getPublication(this.$route.params.id);
        if (data.status) {
          this.publicacion = data.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getCommentarios() {
      try {
        const response = await api.getCommentsByPublicationId(this.$route.params.id);
        if (response.status) {
          this.comentarios = response.data.data.Items;
        }
      } catch (err) {
        console.log(err);
      }
    },
    irAtras() {
      this.$router.go(-1);
    },
  },
};
</script>